import Axios from 'axios';
import header from './auth/header'

const API_URL =  process.env.API_URL + '/api/v1/';
const API_URL_V3 = process.env.API_URL + '/api/v3/';

class Pekerjaan {
  // update(data) {
  //   return Axios.patch(API_URL + 'update-datapekerjaan', data, { headers: header() });
  // }
  update(data) {
    return Axios.post(API_URL_V3 + 'users/personal/job', data, { headers: header() });
  }
}

export default new Pekerjaan();



// WEBPACK FOOTER //
// ./src/api/pekerjaan.js